import React from 'react';
import '../styles/Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <h1 className="header-title">Jewelry Prompt Builder</h1>
      <p className="header-subtitle">For Etsy · YouTube · Instagram · Facebook</p>
    </header>
  );
};

export default Header;







